import { get } from 'lodash-es';
import { EMPTY, of } from 'rxjs';

import { OrderDetailsHelperService } from '../../services/order-details-helper-service';
import { doesFulfillmentPlanNeedServiceMappingApplied } from '../../services/requested-service-mapping/does-fulfillment-plan-need-service-mapping-applied';
import * as CSWActions from '../../store/csw/csw.actions';
import Global from '../../store/global-selectors';

export const mapServiceMappingPackageToFulfillmentPlanPackage = (serviceMappingPackage, fulfillmentPlan) => {
  const [fpPackage] = fulfillmentPlan.packages;
  return {
    ...fpPackage,
    packageTypeId: serviceMappingPackage.packageTypeId,
    packageId: serviceMappingPackage.packageId,
    dimensions: serviceMappingPackage.dimensions,
  };
};

export const updateCSWwithSavedMappings$ = (getState, action) => {
  const state = getState();
  const salesOrderId = Global.selectOrderDetailsSalesOrderId(state);
  const fulfillmentPlanIds = Global.selectEntitiesSalesOrderProperty(state, {
    salesOrderId,
    property: 'fulfillmentPlanIds',
  });

  // Guard against undefined fulfillmentPlanIds
  if (!fulfillmentPlanIds || fulfillmentPlanIds.length === 0) {
    return EMPTY;
  }

  const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, {
    fulfillmentPlanIds,
  });
  const fulfillmentPlan = OrderDetailsHelperService.findPendingFulfillmentPlan(fulfillmentPlans);
  const [selectedId] = Global.selectSelectedOrdersIds(state);
  const fulfillmentPlanId = get(fulfillmentPlan, 'fulfillmentPlanId') || selectedId;
  const fulfillmentPlanSalesOrderIds = Global.selectEntitiesFulfillmentPlanProperty(state, {
    fulfillmentPlanId,
    property: 'salesOrdersFulfilledIds',
  });
  const store =
    fulfillmentPlanSalesOrderIds &&
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId: fulfillmentPlanSalesOrderIds[0],
      property: 'store',
    });
  const orderDetailsStoreGuid = Global.selectEntitiesSalesOrderProperty(state, {
    salesOrderId,
    property: 'store.storeGuid',
  });
  const storeId = store ? get(store, 'storeGuid') : orderDetailsStoreGuid;
  const storeMappings = get(action.data, `${storeId}`, []);
  const requestedService =
    fulfillmentPlanSalesOrderIds &&
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId: fulfillmentPlanSalesOrderIds[0],
      property: 'requestedService',
    });
  const requestedServiceMapping = storeMappings.find((mapping) => mapping.requestedServiceCode === requestedService);
  if (requestedServiceMapping && doesFulfillmentPlanNeedServiceMappingApplied(fulfillmentPlan)) {
    const { labelProviderId } =
      Global.selectSellerServiceById(state, {
        serviceId: requestedServiceMapping.serviceId,
      }) || {};
    const sellerLabelProviders = Global.selectSellerLabelProviders(state) || [];
    const { sellerLabelProviderId } =
      sellerLabelProviders.find((labelProvider) => labelProvider.labelProviderId === labelProviderId && labelProvider.isPrimaryAccount) ||
      sellerLabelProviders.find((labelProvider) => labelProvider.labelProviderId === labelProviderId) ||
      {};

    if (requestedServiceMapping.packageTypeId) {
      const serviceMappingPackage = Global.selectSellerPackages(state).find(
        (pkg) => pkg && pkg.packageTypeId === requestedServiceMapping.packageTypeId,
      );
      return of(
        CSWActions.updateShipmentConfiguration(fulfillmentPlanId, {
          serviceId: requestedServiceMapping.serviceId,
          sellerLabelProviderId,
          packages: serviceMappingPackage ? [mapServiceMappingPackageToFulfillmentPlanPackage(serviceMappingPackage, fulfillmentPlan)] : [],
        }),
      );
    }

    return of(
      CSWActions.updateShipmentConfiguration(fulfillmentPlanId, {
        serviceId: requestedServiceMapping.serviceId,
        sellerLabelProviderId,
      }),
    );
  }
  return EMPTY;
};
